export const setTunnelTestConnectionResult = 'setTunnelTestConnectionResult';
